import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  AMENITIES_CATEGORY_EDIT,
  AMENITIES_CATEGORY_LIST,
} from '../../../../../constants/AmenityConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_AMENITIES,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allAmenitiesSelector,
  allAmenityCategoriesSelector,
  allAmenitySectionsSelector,
} from '../../../../property/propertySlice';
import './Amenity-Category-view.scss';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';

const AmenityCategoryView = (props) => {
  const { amenitiesCategory, onViewToggle, toggleDrawer, permissions } = props;
  const [selectedCategory, setSelectedCategory] = useState(amenitiesCategory);
  const originalAmenityCategories = useSelector(allAmenityCategoriesSelector);
  const originalAmenities = useSelector(allAmenitiesSelector);
  const [tabValue, setTabValue] = useState(0);
  const originalSections = useSelector(allAmenitySectionsSelector);

  useEffect(() => {
    const catObj = {
      ...originalAmenityCategories?.find((cat) => cat.id === amenitiesCategory.id),
      customAttributes: amenitiesCategory?.customAttributes,
    };
    const catAmenities = originalAmenities
      .filter((amenity) => amenity.categoryId === catObj.id)
      .map((c) => c.name);
    catObj['amenities'] = catAmenities;

    setSelectedCategory(catObj);
  }, [originalAmenityCategories, originalAmenities, amenitiesCategory]);

  const onClickEdit = (event) => {
    toggleDrawer(AMENITIES_CATEGORY_EDIT, true, selectedCategory);
  };

  const retrieveNoOfAmenities = (category) => {
    let counter = {};
    let count = 0;
    originalAmenities?.forEach((room) =>
      room?.categoryIds?.forEach((item) => {
        item === category?.id && (counter[category?.name] = count += 1);
      }),
    );
    return counter[category?.name] ? counter[category?.name] : 0;
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const retrieveCompendiums = (category) => {
    let names = [];
    originalAmenities?.forEach((item) => {
      item?.categoryIds?.includes(category?.id) && (names = [...names, item?.name]);
    });
    return names?.length > 0 ? names?.join(', ') : '---';
  };

  const getSectionNames = (sectionIds) => {
    const displayName = sectionIds?.map(
      (itemData) => originalSections?.find((section) => section?.id === itemData)?.name,
    );
    return displayName ? <span>{displayName?.join(', ')}</span> : '';
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12 mb-4'>
                <span className='page-title-secondary'>Details</span>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>Category Name</div>
                <div className='details-value preview-breaks'>{selectedCategory?.name}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-4'>
                <div className='details-label'>No of Hotel Compendiums</div>
                <div className='details-value'>{retrieveNoOfAmenities(selectedCategory)}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Hotel Compendiums</div>
                <div className='details-value'>{retrieveCompendiums(selectedCategory)}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Section Name</div>
                <div className='details-value'>{getSectionNames(selectedCategory?.sectionIds)}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              {selectedCategory?.customAttributes &&
                selectedCategory?.customAttributes?.length > 0 &&
                selectedCategory?.customAttributes?.map((item, index) => (
                  <div key={index} className='col-md-6 mb-2'>
                    <div className='details-label'>{item?.key}</div>
                    <div className='details-value'>{item?.value}</div>
                  </div>
                ))}
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row pt-4 px-3'>
            <MediaViewer
              images={selectedCategory.images}
              videos={selectedCategory.videos}
              gifs={selectedCategory.gifs}
              enabledMediaTabs={['image']}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {selectedCategory && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          tabValue={tabValue}
          handleTabChange={handleTabChange}
          tabList={AMENITIES_CATEGORY_LIST}
          onViewToggle={onViewToggle}
          title={selectedCategory.name}
          createdUserId={selectedCategory.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_AMENITIES] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
        />
      )}
    </>
  );
};

export default AmenityCategoryView;
